import { takeUntil } from 'rxjs/operators';
import { Injectable, OnDestroy } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl implements OnDestroy {
  private unsubscriber$: Subject<void> = new Subject<void>();
  OF_LABEL = 'of';

  constructor(
    private translate: TranslateService
  ) {
    super();

    this.translate.onLangChange
      .pipe(takeUntil(this.unsubscriber$))
      .subscribe(() => {
        this.getAndInitTranslations();
      });

    this.getAndInitTranslations();
  }

  /***** Life Cycle *****/
  ngOnDestroy() {
    this.unsubscriber$.next();
    this.unsubscriber$.complete();
  }

  getAndInitTranslations() {
    this.translate
      .get([
        'PAGINATOR.ITEMS_PER_PAGE',
        'PAGINATOR.NEXT_PAGE',
        'PAGINATOR.PREVIOUS_PAGE',
        'PAGINATOR.OF_LABEL',
      ])
      .pipe(takeUntil(this.unsubscriber$))
      .subscribe(translation => {
        this.itemsPerPageLabel =
          translation['PAGINATOR.ITEMS_PER_PAGE'];
        this.nextPageLabel = translation['PAGINATOR.NEXT_PAGE'];
        this.previousPageLabel =
          translation['PAGINATOR.PREVIOUS_PAGE'];
        this.OF_LABEL = translation['PAGINATOR.OF_LABEL'];
        this.changes.next();
      });
  }

  // getRangeLabel = (
  //   page: number,
  //   pageSize: number,
  //   length: number,
  // ) => {
  //   if (length === 0 || pageSize === 0) {
  //     return `0 ${this.OF_LABEL} ${length}`;
  //   }
  //   length = Math.max(length, 0);
  //   const startIndex = page * pageSize;
  //   const endIndex =
  //     startIndex < length
  //       ? Math.min(startIndex + pageSize, length)
  //       : startIndex + pageSize;
  //   return `${startIndex + 1} - ${endIndex} ${
  //     this.OF_LABEL
  //   } ${length}`;
  // };

  getRangeLabel = (
    page: number,
    pageSize: number,
    length: number,
  ) => {
    if (length === 0 || pageSize === 0) {
      return `第 0，共 ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex =
      startIndex < length
        ? Math.min(startIndex + pageSize, length)
        : startIndex + pageSize;
    return `第 ${startIndex + 1} - ${endIndex}，共 ${length}`;
  };
}